import { smoothScrollTo } from "./smoothScroll";
import type { ScrollSource } from "./events";

export type MoveToOptions = {
  source?: Extract<ScrollSource, "arrows" | "pagination-dots">;
  reducedMotion?: boolean;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const moveToInternal = (
  stage: HTMLElement | undefined,
  getScrollPoints: () => number[],
  setStageScrollSource: (source: ScrollSource) => void,
  targetSlide: number,
  options: MoveToOptions = {},
): void => {
  if (!stage) return;

  /*                     */
  setStageScrollSource(options.source ?? "move-method");

  const scrollPoints = getScrollPoints();
  const targetScroll =
    scrollPoints[Math.max(targetSlide, 0)] ?? scrollPoints[scrollPoints.length - 1];

  if (options.reducedMotion || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    stage.style.scrollBehavior = "auto";
    stage.scrollLeft = targetScroll;
  } else {
    smoothScrollTo(stage, targetScroll);
  }
};
